<style lang='scss'>
	#main-handhome{
		.ant-modal {
			top: 5vh;
		}
		.ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
			border-radius: 0;
		}
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	#mybody-main>div{
		padding: .4rem 0;
	}
	#mybody-main{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			height: 32rem;
		}
		.main-mybody1{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			height: 37rem;
		}
		.look_g{
			font-size: .9rem;
			margin-bottom: .5rem;
			color: #0c8b97;
			div{
				display: inline-block;
				width: 1px;
				height: .9rem;
				position: relative;
				top: .1rem;
				margin-right: .2rem;
				border-left: 3px solid #0c8b97;
			}
		}
		.main-wid{
			width: 100%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .4rem 0;
		}
		.btn-main{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			line-height: 2rem;    
			text-align: center;
			font-size: .8rem;
			color: #fff;
			border: 0;
			background-color: #0c8b97;
		}
		.btn-main1{
			margin: 0 1rem;
			background-color: #c8c8c8;
		}
	}
</style>
<template>
	<div>
		<a-modal
		width='80rem'
		id='main-handhome'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div>
					我的設定檔
				</div>
			</div>
			<div>
				<div v-for='(item,ind) in titlearr' :key='ind + "0716"' 
				:class='island == ind?"wland":"gland"' @click="fanfn(ind)">
					{{item.name}}
				</div>
			</div>
			<div id='mybody-main'>
				<div v-if='island == 0' style="padding :0">
					<lookzero v-if='itedit' :lookfrom='lookfrom'></lookzero>
					<ediozero v-else :lookfrom='lookfrom' ref='ediozero'></ediozero>
					<div class='main-wid'></div>
					<div style="text-align: right;padding-right: 1rem;padding-bottom: 1rem;">
						<button class='btn-main btn-main1' v-if='!itedit' @click='itedit = true'>返回</button>
						<button class='btn-main' @click='handsmal("ediozero")'>{{itedit?"編輯":"保存"}}詳細資料</button>
					</div>
				</div>
				<div v-if='island == 1'>
					<lookfirst v-if='itedit' :lookfrom='lookfrom'></lookfirst>
					<ediofirst v-else :lookfrom='lookfrom' ref='ediofirst'></ediofirst>
					<div class='main-wid'></div>
					<div style="text-align: right;padding-right: 1rem;padding-bottom: 1rem;">
						<button class='btn-main btn-main1' v-if='!itedit' @click='itedit = true'>返回</button>
						<button class='btn-main' @click='handsmal("ediofirst")'>{{itedit?"編輯":"確認"}}登入信息</button>
					</div></div>
				<div v-if='island == 2'>
					<looktwo></looktwo>
				</div>
				<div v-if='island == 3'>
					<lookthree></lookthree>
				</div>
				<div v-if='island == 4'>
					<ediofour></ediofour>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import lookzero from './lookzero.vue'
	import ediozero from './ediozero.vue'
	import lookfirst from './lookfirst.vue'
	import ediofirst from './ediofirst.vue'
	import looktwo from './looktwo.vue'
	import lookthree from './lookthree.vue'
	import ediofour from './ediofour.vue'
		
	export default {
		name:'handhome',
		props:[],
		components:{
			lookzero,ediozero,
			lookfirst,ediofirst,
			looktwo,
			lookthree,
			ediofour
			},
		data(){
			return {
				lookfrom:{},
				visible:true,
				confirmLoading: false,
				island:0,
				itedit:true,
				titlearr:[
					{
						name:'個人詳細資料',
						island:true
					},{
						name:'登入詳細資料',
						island:false
					},{
						name:'權限',
						island:false
					},{
						name:'系統支援',
						island:false
					},{
						name:'活動記錄',
						island:false
					},
				]
			}
		},
		mounted() {
			this.getPers()
		},
		methods:{
			handsmal(valname){
				if(this.itedit){
					this.itedit=!this.itedit
				}else{
					let objform = this.$refs[valname].form
					objform.token = this.$store.state.token
					if(valname == 'ediozero'){
						this.editPer(objform)
					}
					if(valname == 'ediofirst'){
						if(objform.newpassword&&objform.newpassword.length == 8||objform.password&&objform.password.length == 8){
							if(objform.newpassword==objform.password){
								if(this.$refs[valname].passfn(objform.password)){
									return
								}
								this.editPer(objform)
							}else{
								this.$message.warning('新密碼與確認新密碼不等')
							}
						}else{
							objform.password = ''
							this.editPer(objform)
						}
					}
				}
			},
			editPer(obj) {
				let urls = this.$api.editPersonalInfo
				if(this.island == 1){
					urls = this.$api.editPers
				}
				
				this.$ajax({
					url:urls,
					method:'post',
					data:obj
				}).then(res=>{
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.getPers()
						this.itedit=!this.itedit
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			fanfn(ind){
				this.lookfrom = {}
				this.island = ind;
				if(ind == 0||ind == 1){
					this.getPers()
				}else{
					this.itedit=true
				}
			},
			//查询個人詳細資料
			getPers() {
				let urls = this.$api.getPersonalInfo
				if(this.island==1){
					urls = this.$api.getPersonal
				}
				
				this.$ajax({
					url:urls,
					method:'post',
					data:{
						token:this.$store.state.token
					}
				}).then(res=>{
					if (res.data.qmiscode === 1000) {
						let obj = res.data
						
						this.lookfrom = obj
						console.log(this.lookfrom)
					}else{
						this.$message.warning(res.data.qmismsg)
					}
					this.itedit=true
				})
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
